import React from 'react';
import MiamiShowcase from './pages/MiamiShowcase';

const App: React.FC = () => {
  return <MiamiShowcase />;
};

export default App;
